
import _geturl_new from "../utils/_geturl_new";

let lib_path = {
    redpacket : function (sid='') {
        let activity_id = _geturl_new('activity_id')
        let ismsgcode = _geturl_new('ismsgcode')
        let channel = _geturl_new('channel')
        let tids = _geturl_new('tids')
        return window.location.protocol + '//' + window.location.host
        + '/new_pages/redpacket?activity_id=' + activity_id + '&ismsgcode='
        + ismsgcode + '&channel=' + channel
        + '&tids=' + tids + '&sid=' + sid
    }
}
export default lib_path
